const errorMessage = {
  // Error when generate OTP
  OTP_GENERATE_SERVER_ERROR_MESSAGE:
    'OTP tidak dapat dikirim karena sistem bermasalah atau nomor yang Anda masukkan tidak valid',
  OTP_GENERATE_INVALID_PHONE_NUMBER_INVALID_ERROR_MESSAGE: 'Nomor handphone invalid',
  OTP_GENERATE_INVALID_PHONE_NUMBER_NOT_REGISTERED_ERROR_MESSAGE: 'Nomor handphone tidak terdaftar',
  OTP_GENERATE_TIME_ERROR_MESSAGE: 'Anda dapat melakukan request OTP kembali setelah',
  OTP_GENERATE_BLOCKED_ERROR_MESSAGE: 'Nomor Anda telah terblokir selama 1X24 jam',
  OTP_GENERATE_RATE_LIMIT_ERROR_MESSAGE:
    'Anda sudah melakukan permintaan OTP melebihi batas maksimal. Silakan coba beberapa saat lagi',

  // Error when validate OTP
  OTP_INVALID_ERROR_MESSAGE:
    'OTP yang dimasukkan salah. Namun akan tetap kami proses dan mohon untuk mengisi ulang jika nomor yang dimasukkan salah',
  OTP_INVALID_ERROR_MESSAGE_SIMPLE_BOOKING:
    'OTP yang dimasukkan salah, Mohon untuk mengisi ulang jika nomor yang dimasukkan salah',
  OTP_INVALID_ERROR_MESSAGE_LEADS: 'OTP yang dimasukkan salah.',
  OTP_INVALID_ERROR_MESSAGE_LOGIN_REGISTER: 'Kode OTP yang Anda masukkan salah',
  OTP_EXPIRED_ERROR_MESSAGE: 'Kode OTP Telah Expired',
  OTP_BLOCKED_ERROR_MESSAGE: 'Anda telah salah input OTP sebanyak 3x. Silakan tunggu',
  OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER:
    'Anda mencapai batas percobaan OTP, silakan gunakan metode lain atau coba lagi setelah 24 jam',
  OTP_SERVER_ERROR_MESSAGE: 'Maaf, sistem sedang bermasalah. Silakan coba beberapa saat lagi',
  OTP_SERVER_REQUEST_HAS_BEEN_MADE: 'Anda sudah melakukan permintaan ini.',

  // Auth error message
  AUTH_SERVER_ERROR_MESSAGE: 'Maaf sistem sedang bermasalah. Silakan coba beberapa saat lagi',
  OTP_5X_REQUEST_ERROR_MESSAGE:
    'Anda telah melakukan 5X percobaan gagal, silakan coba lagi dalam 1 menit',
  GENEREL_SERVER_ERRPR_MESSAGE:
    'Mohon Maaf Sistem Sedang Bermasalah. Silahkan Coba Beberapa Saat Lagi',

  // Captcha Invalid Message
  CAPTCHA_INVALID_MESSAGE: 'Maaf Anda Gagal diverifikasi. Silahkan coba beberapa saat lagi.',

  // Used Car Input Multiple Time With Same Car and Same Account
  USED_CAR_DUPLICATE_USED_CAR_LEAD: 'Duplicate Used Car Lead',
  // Test Drive
  TEST_DRIVE_OTP_INVALID_MESSAGE: 'Anda salah memasukan Kode OTP sebanyak',
};

export default errorMessage;
